<script>
import mixinComponent from '../../components/js/Mixins/mixinComponent.js'
import { globalVariablesMixin } from '../../components/js/Mixins/global.js'
import MainContainer from '../../components/js/Components/UI/Content/MainContainer.vue'
import MainContent from '../../components/js/Components/UI/Content/MainContent.vue'
import PageLayout from '../../components/js/Components/UI/PageLayout.vue'
import ContractRestructuringForm from '../../components/js/Components/ContractRestructuring/ContractRestructuringForm.vue'

export default {
  components: { ContractRestructuringForm, PageLayout, MainContent, MainContainer },
  mixins: [mixinComponent, globalVariablesMixin],
}
</script>
<template>
  <PageLayout menu="restructuring">
    <MainContainer>
      <MainContent>
        <ContractRestructuringForm />
      </MainContent>
    </MainContainer>
  </PageLayout>
</template>
